import { Types } from './types'

const initialState = {
    dataRole: {
        filter: {},
        rows: [],
    }
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_ROLE:
            return {
                ...newState,
                dataRole: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
